export default function (arr, item) {
  if (arr && Array.isArray(arr)) return arr.includes(item)
  return false
}
